const API_REQUEST = 'API_REQUEST';
const API_SUCCESS = 'API_SUCCESS';
const API_FAIL = 'API_FAIL';

const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const STORE_TOKEN = 'STORE_TOKEN';
const AUTHENTICATE = 'AUTHENTICATE';
const SET_AUTH_STATE = 'SET_AUTH_STATE';
const SET_PROFILE = 'SET_PROFILE';

const READ_TOKEN = 'READ_TOKEN';

export {
  READ_TOKEN,
  API_REQUEST,
  API_SUCCESS,
  API_FAIL,
  LOGIN,
  LOGOUT,
  STORE_TOKEN,
  AUTHENTICATE,
  SET_AUTH_STATE,
  SET_PROFILE,
};
